import {make} from "vuex-pathify";
import {ApplicationService} from "@/services";
import store from "@/store";
import AppService from "@/services/app.service";
import helpers from "@/util/helpers";
import Vue from "vue";
import router from "@/router";
import _ from "lodash";
import BaseRestMutations from "@/store/base-rest.mutations";

const state = {
    items: [],
    currentApp: {},
    search: '',
    filter: 'All'
}
const mutations = BaseRestMutations(state)

const actions = {
    ...make.actions(state),
    create({commit}, application) {
        store.set('app/loading', true)
        ApplicationService.create(application)
            .then((res) => {
                commit('pushItem', res.data)
                AppService.toastSuccess("Create application successfully")
                store.set('dialogs/showAppCreator', false)
            })
            .catch(() => {
                AppService.toastError("Create application failed")
            })
            .finally(() => {
                store.set('app/loading', false)
            })
    },
    findAll({dispatch}) {
        store.set('app/loading', true)
        ApplicationService.findAll()
            .then(res => {
                dispatch('setItems', res.data)
            })
            .catch(() => {
                AppService.toastError("Get list application failed")
            })
            .finally(() => {
                store.set('app/loading', false)
            })
    },
    findOne({dispatch}) {
        const appId = router.currentRoute.params.appId;
        store.set('app/loading', true)

        ApplicationService.findOne(appId)
            .then((res) => {
                dispatch('setCurrentApp', res.data)
            })
            .catch(() => {
                AppService.toastError("Get application failed")
            })
            .finally(() => {
                store.set('app/loading', false)
            })
    },
    updateWithConfirm({dispatch, state}, item) {
        Vue.$confirm(
            {
                message: `You sure want to update the application status?`,
                button: {
                    no: 'Cancel',
                    yes: 'OK'
                },
                callback: confirm => {
                    if (confirm) {
                        dispatch('updateWithoutConfirm', item)
                    } else {
                        if (!_.isEmpty(state.currentApp)) {
                            dispatch('setCurrentApp', {
                                ...state.currentApp,
                                status: state.currentApp.status === "active" ? "inactive" : "active"
                            })
                        }
                    }
                }
            }
        )
    },
    updateWithoutConfirm({commit, dispatch, state}, item) {
        store.set('app/loading', true)
        ApplicationService.update(item.id, item)
            .then((res) => {
                commit('updateItem', res.data)
                if (!_.isEmpty(state.currentApp)) {
                    dispatch('setCurrentApp', res.data)
                }
                AppService.toastSuccess("Update application successfully")
            })
            .catch(() => {
                AppService.toastError("Update application failed")
            })
            .finally(() => {
                store.set('app/loading', false)
            })
    },
    remove({commit}, id) {
        Vue.$confirm(
            {
                message: `You sure want to remove application?`,
                button: {
                    no: 'Cancel',
                    yes: 'OK'
                },
                callback: confirm => {
                    if (confirm) {
                        store.set('app/loading', true)
                        ApplicationService.remove(id)
                            .then(() => {
                                commit('removeItem', id);
                                AppService.toastSuccess("Remove application successfully")
                            })
                            .catch(() => {
                                AppService.toastError("Remove application failed")
                            })
                            .finally(() => {
                                store.set('app/loading', false)
                            })
                    }
                }
            }
        )

    },
}

const getters = {
    filteredItems: (state) => {
        const _search = helpers.removeVietnameseTones(state.search).toLowerCase()
        const _filter = state.filter.toLowerCase();
        return state.items.filter(item => {
            const name = helpers.removeVietnameseTones(item.name)
            const id = helpers.removeVietnameseTones(item.id)
            return (item.status === _filter || _filter === 'all') && (name.toLowerCase().includes(_search) || id.toLowerCase().includes(_search))
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
